import { computed, ComputedRef, Ref } from 'vue';
import _ from 'lodash';
import { formatDate } from '@vueuse/core';
import { PaazlShippingOption } from '@/types/Paazl/PaazlShippingOption.ts';

export function useDeliveryOptionsComposable(
  options: Ref<PaazlShippingOption[]>
) {
  const tomorrowDate: ComputedRef<Date> = computed(() => {
    // Get the date of tomorrow
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    return tomorrow;
  });

  const dayAfterTomorrowDate: ComputedRef<Date> = computed(() => {
    // Get the date of tomorrow
    const dayAfterTomorrow = new Date();
    dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);

    return dayAfterTomorrow;
  });

  const hasTodayDelivery = computed(() => isDateInDeliveryOptions(new Date()));
  const hasTomorrowDelivery = computed(() =>
    isDateInDeliveryOptions(tomorrowDate.value)
  );
  const hasDayAfterTomorrowDelivery = computed(() =>
    isDateInDeliveryOptions(dayAfterTomorrowDate.value)
  );

  function isDateInDeliveryOptions(date: Date): boolean {
    // Get all dates
    const dates = _.map(options.value, 'date.deliveryDate');

    // Check if the date is in the dates so there is delivery on that date
    return dates.includes(formatDate(date, 'YYYY-MM-DD'));
  }

  return {
    hasTodayDelivery,
    hasTomorrowDelivery,
    hasDayAfterTomorrowDelivery,
  };
}
